import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAFF_ROLES_INFO].GET_REGULATIONS_STAFF_ROLES_INFO]: {
		url:'/company/:companyId/regulations/:regulationId/staff_roles_info/',
	}
}